/*
 * AdminAgendaPage Messages
 *
 * This contains all the text for the AdminAgendaPage container.
 */

import { defineMessages } from "react-intl";

export const scope = "app.containers.AdminAgendaPage";

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: "Agendas",
  },
  title: {
    id: `${scope}.title`,
    defaultMessage: "Search Filters",
  },
  drivers: {
    id: `${scope}.drivers`,
    defaultMessage: "Search drivers",
  },
  appointment: {
    id: `${scope}.appointment`,
    defaultMessage: "Appointments",
  },
  practice: {
    id: `${scope}.practice`,
    defaultMessage: "Practice",
  },
  treatment: {
    id: `${scope}.treatment`,
    defaultMessage: "Treatment",
  },
  plan: {
    id: `${scope}.plan`,
    defaultMessage: "Treatment plan",
  },
  product: {
    id: `${scope}.product`,
    defaultMessage: "Product",
  },
  kpter: {
    id: `${scope}.kpter`,
    defaultMessage: "KPT'er",
  },
  patient: {
    id: `${scope}.patient`,
    defaultMessage: "Patient",
  },
  internalRef: {
    id: `${scope}.internalRef`,
    defaultMessage: "Internal Number",
  },
  insurer: {
    id: `${scope}.insurer`,
    defaultMessage: "Insurer",
  },
  insuranceNumber: {
    id: `${scope}.insuranceNumber`,
    defaultMessage: "Insurance Number",
  },
  dentist: {
    id: `${scope}.dentist`,
    defaultMessage: "Dentist",
  },
  treatmentPlanUpperJaw: {
    id: `${scope}.treatmentPlanUpperJaw`,
    defaultMessage: "TreatmentPlan Upper jaw",
  },
  upperJaw: {
    id: `${scope}.upperJaw`,
    defaultMessage: "Upper jaw",
  },
  lowerJaw: {
    id: `${scope}.lowerJaw`,
    defaultMessage: "Lower jaw",
  },
  implant: {
    id: `${scope}.implant`,
    defaultMessage: "( {count} implants )",
  },
  treatmentPlanLowerJaw: {
    id: `${scope}.treatmentPlanLowerJaw`,
    defaultMessage: "TreatmentPlan Lower jaw",
  },
  treatmentPhase: {
    id: `${scope}.treatmentPhase`,
    defaultMessage: "Treatment Phase",
  },
  customer: {
    id: `${scope}.customer`,
    defaultMessage: "Customer",
  },
  other: {
    id: `${scope}.other`,
    defaultMessage: "Other",
  },
  day: {
    id: `${scope}.day`,
    defaultMessage: "Day",
  },
  week: {
    id: `${scope}.week`,
    defaultMessage: "Week",
  },
  durationMin: {
    id: `${scope}.durationMin`,
    defaultMessage: "Duration",
  },
  occupiedMin: {
    id: `${scope}.occupiedMin`,
    defaultMessage: "Occupied",
  },
  maxGapMin: {
    id: `${scope}.maxGapMin`,
    defaultMessage: "Max gap",
  },
  comment: {
    id: `${scope}.comment`,
    defaultMessage: "Comment",
  },
});
